<template>
    <v-container max-width="100%" style="margin-top: 2%">
      <template>
        <v-row justify="center">
          <v-dialog v-model="confirmDialog" persistent max-width="500">
            <v-card>
              <v-card-title class="headline">
                <span style="color: #d60000">{{ $t('system.alert') }}</span>
              </v-card-title>
              <v-card-text>
                <span style="color: #d60000">{{ this.mensagemdialog }}</span>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="red accent-4"
                  class="white--text"
                  @click="confirmDialog = false"
                  >{{ this.messageDismissButton }}</v-btn
                >
                <v-btn
                  v-if="showConfirmButton"
                  color="red accent-4"
                  class="white--text"
                  @click="confirm"
                  >{{ this.messageConfirmButton }}</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
      </template>

    <merus-data-table :headers="headersTipos" :items="tipos" :loading="loadingTipos"
      :default-multi-sort="defaultSortTipos" :loading-text="$t('reasonsTypesRegistration.types.loadingType')" @update:displayedItems="displayedTypesItemsForExport = $event"

 cod-tabela="MOTIVOS__TIPOS" @update:headers="headersTipos = $event">
      <template v-slot:toolbar>
        <CadastroToolbar :title="$t('reasonsTypesRegistration.types.title')" :token="token" :items="displayedTypesItemsForExport !== null ? displayedTypesItemsForExport : tipos"
          csv-title="tipos" :pdf-title="$t('reasonsTypesRegistration.types.logbookTitle')" :pdf-headers="headersTipos"
          pdf-filename="tipos" hide-search>
          <template v-slot:add v-if="canInsert">
            <v-dialog v-model="dialogTipo" max-width="80%">
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="primary" dark small class="mb-2" v-bind="attrs" v-on="on" fab>
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline" style="color: #4a4a4a">{{ formTitleTipo }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-form ref="formTipo" v-model="formValidadoTipo">
                      <v-row>
                        <v-col cols="12" sm="2" md="4">
                          <v-text-field v-model="editedItemTipo.cod_tipo_entrada"
                            :label="$t('reasonsTypesRegistration.types.codeType')"
                            :rules="[codMotivoRules(editedItemTipo.cod_tipo_entrada)]"
                            :disabled="isCodigoTipoDisabled"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="8" md="8">
                          <v-text-field v-model="editedItemTipo.descricao_tipo_entrada"
                            :label="$t('reasonsTypesRegistration.headers.description')"
                            :rules="[(v) => !!v || $t('reasonsTypesRegistration.validation.requiredType')]"></v-text-field>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary darken-1" class="white--text" @click="closeTipo">{{ $t('button.cancel')
                    }}</v-btn>
                  <v-btn color="primary darken-1" class="white--text" @click="saveTipo">{{ $t('button.save') }}</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </template>
        </CadastroToolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" color="green" @click="editItemTipo(item)"
          :disabled="item.id_tipo_entrada_diario == 1">mdi-pencil</v-icon>
        <v-icon small class="mr-2" color="red" @click="deleteItemTipo(item)"
          :disabled="item.deletable == 0">mdi-delete</v-icon>
      </template>
    </merus-data-table>

    <merus-data-table :headers="headers" :items="motivos" :loading="loadingMotivos" :default-multi-sort="defaultSort"
      :loading-text="$t('reasonsTypesRegistration.reasons.loadingReasons')" @update:displayedItems="displayedReasonsItemsForExport = $event"

 cod-tabela="MOTIVOS" @update:headers="headers = $event">
      <template v-slot:toolbar>
        <CadastroToolbar :title="$t('reasonsTypesRegistration.reasons.title')" :token="token" :items="displayedReasonsItemsForExport !== null ? displayedReasonsItemsForExport : motivos" :csv-title="$t('reasonsTypesRegistration.reasons.title')"
          :pdf-title="$t('reasonsTypesRegistration.reasons.logbookTitle')" :pdf-headers="headers" pdf-filename="motivos"
          hide-search>

          <template v-slot:add v-if="canInsert">
            <v-dialog v-model="dialog" max-width="80%">
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="primary" dark small class="mb-2" v-bind="attrs" v-on="on" fab>
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline" style="color: #4a4a4a">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-form ref="form" v-model="formValidado">
                      <v-row>
                        <v-col cols="12" sm="2" md="4">
                          <v-text-field v-model="editedItem.cod_motivo"
                            :label="$t('reasonsTypesRegistration.reasons.codeReason')"
                            :rules="[codMotivoRules(editedItem.cod_motivo)]"
                            :disabled="isCodigoDisabled"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="8" md="8">
                          <v-text-field v-model="editedItem.descricao_motivo"
                            :label="$t('reasonsTypesRegistration.headers.description')"
                            :rules="[(v) => !!v || $t('reasonsTypesRegistration.validation.requiredReason')]"></v-text-field>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary darken-1" class="white--text" @click="close">{{ $t('button.cancel') }}</v-btn>
                  <v-btn color="primary darken-1" class="white--text" @click="save">{{ $t('button.save') }}</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </template>
        </CadastroToolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" color="green" @click="editItem(item)" :disabled="!canEdit">mdi-pencil</v-icon>
        <v-icon small class="mr-2" color="red" @click="deleteItem(item)"
          :disabled="item.deletable == 0 || !canDelete">mdi-delete</v-icon>
      </template>
    </merus-data-table>
  </v-container>
</template>

<script>

import apiController from "@/utils/apiController";
import { validador } from "@/constants";
import MerusDataTable from "./Tables/MerusDataTable.vue";
import CadastroToolbar from "./Toolbars/CadastroToolbar.vue";
import EventBus from '../utils/eventBus';
import translateDbField from "@/utils/translateDbField";

export default {
  components: {
    MerusDataTable,
    CadastroToolbar
  },
  data: () => ({
    headers: [],
    headersTipos: [],
    search: "",
    user: null,
    token: null,
    autorizacaoDialog: false,
    mensagemAutorizacaoDialog: "",
    showConfirmButton: true,
    formValidado: true,
    formValidadoTipo: true,
    showAlert: false,
    mensagemAlerta: "",
    tipoAlerta: "success",
    searchTipo: "",
    loadingTipos: false,
    dialogTipo: false,
    dialog: false,
    operacao: 0,
    confirmDialog: false,
    mensagemdialog: "",
    isCodigoDisabled: false,
    isCodigoTipoDisabled: false,
    loadingMotivos: false,
    displayedReasonsItemsForExport: null,
    displayedTypesItemsForExport: null,
    motivos: [],
    tipos: [],
    editedIndex: -1,
    editedIndexTipo: -1,
    editedItem: {
      id_motivo: null,
      cod_motivo: null,
      descricao_motivo: null
    },
    deletedItem: {
      id_motivo: null,
      cod_motivo: null,
      descricao_motivo: null
    },
    defaultItem: {
      id_motivo: null,
      cod_motivo: null,
      descricao_motivo: null
    },
    editedItemTipo: {
      id_tipo_entrada_diario: null,
      cod_tipo_entrada: null,
      descricao_tipo_entrada: null
    },
    deletedItemTipo: {
      id_tipo_entrada_diario: null,
      cod_tipo_entrada: null,
      descricao_tipo_entrada: null
    },
    defaultItemTipo: {
      id_tipo_entrada_diario: null,
      cod_tipo_entrada: null,
      descricao_tipo_entrada: null
    },
    recursos: [],
    canInsert: false,
    canEdit: false,
    canDelete: false,
  }),
  computed: {
      messageDismissButton() {return this.$t('button.dismiss')},
      messageConfirmButton() {return this.$t('button.confirm')},
    defaultSort() {
      return [
      { value: 'cod_motivo', options: { text: this.$t('system.labels.increasing'), value: 1 } }];

    },
    defaultSortTipos() {
      return [
      { value: 'cod_tipo_entrada', options: { text: this.$t('system.labels.increasing'), value: 1 } }];

    },
    formTitle() {
      return this.editedIndex === -1 ? this.$t('reasonsTypesRegistration.reasons.registerReason') : this.$t('reasonsTypesRegistration.reasons.editReason');
    },
    formTitleTipo() {
      return this.editedIndexTipo === -1 ? this.$t('reasonsTypesRegistration.types.registerType') : this.$t('reasonsTypesRegistration.types.editType');
    },
  },
  watch: {
    '$i18n.locale'() {
      this.initialize();
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    }
  },
  created() {
    this.user = JSON.parse(sessionStorage.getItem("user"));
    this.token = sessionStorage.getItem("api");
    this.populaRecursos();
  },
  mounted() {
  },
  methods: {

    populaRecursos() {
      if (this.user.is_superadmin === 1) {
        apiController.request(apiController.endpoints.getallRecursos, {
          onSuccess: (response) => {
            this.recursos = response.data;
            this.canEdit = true;
            this.canInsert = true;
            this.canDelete = true;
            this.initialize();
          },
        });
      } else {
        apiController.request(apiController.endpoints.getRecursosusuario, {
          params: { id: this.user.id_usuario },
          onSuccess: (response) => {
            this.recursos = response.data;
            this.canEdit = this.recursos.some((r) => r.rota === "/api/v1.0/updatemotivo");
            this.canInsert = this.recursos.some((r) => r.rota === "/api/v1.0/insertmotivo");
            this.canDelete = this.recursos.some((r) => r.rota === "/api/v1.0/deletemotivo");
            this.initialize();
          },
        });
      }
    },
    initialize() {
      this.populaMotivos();
      this.populaTipos();
    },
    populaMotivos() {
      this.loadingMotivos = true;
      apiController.request(apiController.endpoints.getallMotivos, {
          onSuccess: (response) => {
            this.motivos = response.data
            this.loadingMotivos = false;
          },
          onError: () => {
            this.loadingMotivos = false;
          },
        });
      },
      populaTipos() {
        this.loadingTipos = true;
        apiController.request(apiController.endpoints.getallTiposentrada, {
          onSuccess: (response) => {
            this.tipos = response.data
            this.tipos.forEach(tipo => {
              tipo.descricao_tipo_entrada = translateDbField(
                tipo.translation_key,
                tipo.descricao_tipo_entrada
              );
              return tipo;
            });
            this.loadingTipos = false;
          },
          onError: () => {
            this.loadingTipos = false;
          },
        });
      },
      editItem(item) {
        this.editedIndex = this.motivos.indexOf(item);
        this.editedItem = Object.assign({}, item);
        // this.isCodigoDisabled = true;
        this.dialog = true;
      },
      deleteItem(item) {
        this.deletedItem = Object.assign({}, item);
        this.mensagemdialog = "Confirma a deleção do motivo " + item.cod_motivo + " ?";
        this.showConfirmButton = true;
        this.messageDismissButton = "Não";
        this.messageConfirmButton = "Sim";
        this.confirmDialog = true;
      },
      editItemTipo(item) {
        this.editedIndexTipo = this.tipos.indexOf(item);
        this.editedItemTipo = Object.assign({}, item);
        // this.isCodigoTipoDisabled = true;
        this.dialogTipo = true;
      },
      deleteItemTipo(item) {
        this.deletedItemTipo = Object.assign({}, item);
        this.mensagemdialog = "Confirma a deleção do tipo " + item.cod_tipo_entrada + " ?";
        this.showConfirmButton = true;
        this.messageDismissButton = "Não";
        this.messageConfirmButton = "Sim";
        this.confirmDialog = true;
      },
      deleteFromDatabase() {
        this.operacao = 2;
        this.confirmDialog = false;

      apiController.request(apiController.endpoints.deleteMotivo, {
          data: this.deletedItem,
          onSuccess: (response) => {
            this.updateTable(response);
          },
        });
      },
      deleteTipoFromDatabase() {
        this.operacao = 2;
        this.confirmDialog = false;

      apiController.request(apiController.endpoints.deleteTipoentrada, {
          data: this.deletedItemTipo,
          onSuccess: (response) => {
            this.updateTable(response);
          },
        });
      },
      close() {
        this.dialog = false;
        if (this.$refs.form) {
          this.$refs.form.resetValidation();
        }
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
          this.isCodigoDisabled = false;
        });
      },
      save() {
        this.$refs.form.validate();
        if (this.formValidado) {
          if (this.editedIndex == -1) {
            this.operacao = 0;
            apiController.request(apiController.endpoints.insertMotivo, {
              data: this.editedItem,
              silent: true,
              onSuccess: (response) => {
                this.updateTable(response);
              },
              onError: (e) => {
                console.log(this.$t('system.messages.errorAxios'));
                console.log(e.message);
                if (e.message == "Request failed with status code 401") {
                  this.mensagemAutorizacaoDialog =
                    this.$t('system.messages.accessDenied');
                  this.autorizacaoDialog = true;
                }
              },
            });
        } else {
          this.operacao = 1;
          apiController.request(apiController.endpoints.updateMotivo, {
              data: this.editedItem,
              onSuccess: (response) => {
                this.updateTable(response)
              },
            });
          }
        }
      },
      closeTipo() {
        this.dialogTipo = false;
        if (this.$refs.formTipo) {
          this.$refs.formTipo.resetValidation();
        }
        this.$nextTick(() => {
          this.editedItemTipo = Object.assign({}, this.defaultItemTipo);
          this.editedIndexTipo = -1;
          this.isCodigoTipoDisabled = false;
        });
      },
      saveTipo() {
        this.$refs.formTipo.validate();
        if (this.formValidadoTipo) {
          if (this.editedIndexTipo == -1) {
            this.operacao = 0;
            apiController.request(apiController.endpoints.insertTipoentrada, {
              data: this.editedItemTipo,
              silent: true,
              onSuccess: (response) => {
                this.updateTable(response);
              },
              onError: (e) => {
                console.log(this.$t('system.messages.errorAxios'));
                console.log(e.message);
                if (e.message == "Request failed with status code 401") {
                  this.mensagemAutorizacaoDialog =
                    this.$t('system.messages.accessDenied');
                  this.autorizacaoDialog = true;
                }
              },
            });
        } else {
          this.operacao = 1;
          apiController.request(apiController.endpoints.updateTipoentrada, {
              data: this.editedItemTipo,
              onSuccess: (response) => {
                this.updateTable(response)
              },
            });
          }
        }
      },
      updateTable(response) {
        if (response.data.erro) {
          let mensagem;
          if (this.operacao == 0) {
            mensagem = "Erro na inclusão: " +  response.data.mensagem;
          } else {
            if (this.operacao == 1) {
              mensagem = "Erro na alteração do cadastro: " + response.data.mensagem;
            } else {
              mensagem = "Erro na exclusão:  " + response.data.mensagem;
            }
          }
          EventBus.$emit('show-alert', { mensagem: mensagem, tipo: 'error' });
        } else {
          let mensagem;
          if (this.operacao == 0) {
            mensagem = "Incluído com sucesso";
          } else {
            if (this.operacao == 1) {
              mensagem = "Alterado com sucesso";
            } else {
              mensagem = "Excluído com sucesso";
            }
          }
          EventBus.$emit('show-alert', { mensagem: mensagem, tipo: 'success' });
        }
        this.close();
        this.closeTipo();
        this.initialize();
    },
    codMotivoRules(item) {
      if (!validador(item, 1, 30, 0, 1)) {
        return this.$t('reasonsTypesRegistration.validation.invalidCode');
      } else {
        return true;
      }
    },
    confirm() {
      if (this.deletedItem.id_motivo) {
        this.deleteFromDatabase();
      } else {
        this.deleteTipoFromDatabase();
      }
    }
  },
};
</script>